import { render } from "./table-header-item.vue?vue&type=template&id=18a772d8"
import script from "./table-header-item.vue?vue&type=script&lang=ts"
export * from "./table-header-item.vue?vue&type=script&lang=ts"

import "./table-header-item.vue?vue&type=style&index=0&id=18a772d8&lang=less&scooped=true"
script.render = render

export default script